import { Pipe, PipeTransform } from '@angular/core';

import { IConstantItem } from '../../core/models/available-types.interface';
import { DeliveryStatusLabelPipe } from './delivery-status-label.pipe';

/** Filters sale order status options by enum name, id, or deliveryStatusLabel text. */
@Pipe({
    name: 'filterSaleOrderStatus',
    pure: false,
})
export class FilterSaleOrderStatusPipe implements PipeTransform {
    private readonly deliveryStatusLabel = new DeliveryStatusLabelPipe();

    transform(
        items: IConstantItem[] | undefined | null,
        searchText: string | undefined | null,
    ): IConstantItem[] {
        if (!items?.length) {
            return [];
        }
        if (!searchText?.trim()) {
            return items;
        }

        const q = searchText.trim().toLowerCase();
        return items.filter((item) => {
            const name = item.name?.toLowerCase() ?? '';
            const id = String(item.id ?? '');
            const label = this.deliveryStatusLabel.transform(item.id).toLowerCase();
            return name.includes(q) || label.includes(q) || id.includes(q);
        });
    }
}
